// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  const mv = document.documentElement.querySelector('.topMv')
  const mvBgImg = document.documentElement.querySelector('.topMv__bg img')
  if (!mvBgImg) return

  const onMvBgLoad = () => {
    mv.classList.add('animated')
  }

  if (mvBgImg.complete && mvBgImg.naturalWidth > 0) {
    setTimeout(() => {
      onMvBgLoad()
    }, 300)
  } else {
    mvBgImg.addEventListener('load', onMvBgLoad, { once: true })
  }
}
